import { accreditedOnlineColleges } from './accreditedOnlineColleges'
import { onlineCriminalJusticeDegree } from './onlineCriminalJusticeDegree'
import { onlineMbaPrograms } from './onlineMbaPrograms'
import { onlineMedicalAssistantPrograms } from './onlineMedicalAssistantPrograms'
import { onlineNursingPrograms } from './onlineNursingPrograms'
import type { Article } from './types'

export type {
  Article,
  ArticleCTA,
  ArticleFAQ,
  ArticleInternalLink,
  ArticleSection,
  ArticleSubsection,
} from './types'

export const articles: Article[] = [
  onlineMbaPrograms,
  onlineNursingPrograms,
  accreditedOnlineColleges,
  onlineMedicalAssistantPrograms,
  onlineCriminalJusticeDegree,
]

export function getArticleBySlug(slug: string): Article | undefined {
  const normalized = slug.toLowerCase()
  return articles.find((article) => article.slug.toLowerCase() === normalized)
}

export function getRelatedArticles(slug: string, limit = 3): Article[] {
  return articles.filter((article) => article.slug !== slug).slice(0, limit)
}
